export const FLIGHT_INFO = 'FLIGHT_INFO'
export const STATION_FILTER = 'STATION_FILTER'
export const PASSENGER = 'PASSENGER'
export const MTOW = 'M_TOW'
export const WEIGHT_ALERT = 'WEIGHT_ALERT'

//Ss added
export const PASSENGERINBOUND = 'PASSENGERINBOUND'
export const PASSENGERTERMINATOR = 'PASSENGERTERMINATOR' //Terminator Flight Constant

//investigate modal
export const STATION_DROPDOWN = 'STATION_DROPDOWN'


